import {
  ContentCompact,
  EmptyState,
  PaymentPendingIllustration,
  Section,
  TitleAndDescription,
  useOriginUrl,
} from '@ferreri/prever-component-lib';
import { HeaderHome } from 'components/headers/HeaderNotification';
import useCurrentAccountContracts from 'contractLegacy/useLegacyCurrentAccountContracts';
import { useWhatsappApi } from 'utils/useWhatsappApi';

export const OverdueBenefitUsage = () => {
  const baseUrl = useOriginUrl();
  const query = useCurrentAccountContracts();

  const { handleSendWhatsappMessage } = useWhatsappApi({
    phone: '+558000066688',
    text: 'Olá, eu gostaria de informações sobre as mensalidades em atraso.',
  });

  const isContractsEmpty = query?.data?.length === 0;
  const contractSeqControl = query?.data?.[0]?.seqControl;
  const contractsUrl = `${baseUrl}/contracts-legacy`;
  const billsUrl = isContractsEmpty
    ? contractsUrl
    : `${contractsUrl}/${contractSeqControl}/payment-options`;

  return (
    <ContentCompact>
      <HeaderHome />
      <Section>
        <TitleAndDescription
          title="Mensalidades em atraso"
          description="Para acessar a Teleconsulta Veterinária e outros benefícios, você precisa regularizar o seu plano."
        />

        <EmptyState
          description="O pagamento é rápido e o benefício é liberado assim que ele for processado."
          illustration={<PaymentPendingIllustration />}
          buttonLabelPrimary="Pagar mensalidades"
          onClickButtonPrimary={() => document.location.replace(billsUrl)}
          buttonLabelSecondary="Entrar em contato pelo Whatsapp"
          onClickButtonSecondary={handleSendWhatsappMessage}
        />
      </Section>
    </ContentCompact>
  );
};
